import type React from "react";
import {useLocation, useNavigate} from "react-router-dom";

import {faArrowLeft, faHome} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import {useVersionCheck} from "~/hooks/useVersionCheck";

import UserHubModalButton from "../hub/UserHubModalButton";
import CustomButton from "./CustomButton";

interface AppHeaderProps {
  title?: string;
  parentPath?: string; // Path to navigate back to
}

const AppHeader: React.FC<AppHeaderProps> = ({
  title = "Orbit Dash",
  parentPath,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isHome =
    location.pathname === "/home" ||
    location.pathname === "/" ||
    location.pathname === "";

  useVersionCheck();

  return (
    <header className="fixed top-0 left-0 w-full flex justify-between items-center py-2 px-4 z-50 bg-gradient-to-b from-transparent to-black/50 transition-colors duration-300">
      {/* Left Section: Back Button or Home Button */}
      <div className="flex items-center">
        {parentPath ? (
          <CustomButton
            aria-label={"Back"}
            onClick={() => navigate(parentPath)}
            className="p-2 rounded-full hover:bg-black hover:bg-opacity-70 transition-colors"
          >
            <FontAwesomeIcon
              icon={faArrowLeft}
              size="xl"
              className="text-white p-2 -m-2 rounded-full bg-gradient-to-br from-blue-600 via-blue-500 to-black"
            />
          </CustomButton>
        ) : (
          !isHome && (
            <CustomButton
              aria-label={"Home"}
              onClick={() => navigate("/home")}
              className="p-2 rounded-full hover:bg-black hover:bg-opacity-70 transition-colors"
            >
              <FontAwesomeIcon
                icon={faHome}
                size="xl"
                className="text-white p-2 -m-2 rounded-full bg-gradient-to-br from-blue-600 via-blue-500 to-black"
              />
            </CustomButton>
          )
        )}
      </div>

      {/* Center Section: Title */}
      <div
        className="text-3xl font-normal uppercase cursor-pointer truncate ml-1 mr-1"
        onClick={() => window.location.reload()}
        style={{textShadow: "0 0 5px rgba(0,0,0,0.8)"}}
      >
        {title}
      </div>

      {/* Right Section: User and Settings Buttons */}
      <div className="flex items-center space-x-2">
        <UserHubModalButton />
      </div>
    </header>
  );
};

export default AppHeader;
